<i18n>{
  "fr": {
    "name-alert": {
      "1": "Choisir les",
      "2": "nom et prénom",
      "3": "indiqués sur les papiers d'identité utilisés sur ce vol (obligatoires même pour les mineurs). Si vous utilisez un nom et prénom d'usage pour ce vol, pensez à mettre à jour l'information dans votre profil sur le site WEB de l'AISC dans votre espace personnel."
    }
  },
  "en": {
    "name-alert": {
      "1": "Choose the",
      "2": "first and last name",
      "3": "indicated on the identity papers used on this flight (obligatory even for minors). If you are using a first or last name of use for this flight, remember to update the information in your profile on the AISC website in your personal space."
    }
  }
}
</i18n>

<template>
  <div>
    <v-alert
      border="left"
      class="mb-2"
      type="info"
    >
      <span>{{ $t('name-alert.1') }}</span>&nbsp;
      <span><b>{{ $t('name-alert.2') }}</b></span>&nbsp;
      <span>{{ $t('name-alert.3') }}</span>
    </v-alert>

    <FlightTravellerDetails
      v-for="(traveller, index) in selectedTravellers"
      :key="traveller.registration_number"
      :index="index"
      :traveller="traveller"
      class="my-2"
    />

    <FlightLuggageOptions
      v-if="areLuggageOptionsCommon || areLuggageOptionsOutward || areLuggageOptionsReturn"
      :options-params="itinerary.luggage_options_params"
      :are-luggage-options-common="areLuggageOptionsCommon"
      :are-luggage-options-outward="areLuggageOptionsOutward"
      :are-luggage-options-return="areLuggageOptionsReturn"
    />

    <UserContactDetails
      :can-submit="canSubmit"
      class="mt-2"
      @submitForm="submitForm"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FlightTravellerDetails from './FlightTravellerDetails/FlightTravellerDetails'
import FlightLuggageOptions from './FlightLuggageOptions/FlightLuggageOptions'
import UserContactDetails from './FlightCustomerContactDetails/FlightCustomerContactDetails'

export default {
  name: 'FlightPassengersInformation',

  components: {
    FlightTravellerDetails,
    FlightLuggageOptions,
    UserContactDetails
  },
  data: () => ({
    areLuggageOptionsOutward: undefined,
    areLuggageOptionsReturn: undefined,
    areLuggageOptionsCommon: undefined,
    luggageIncluded: undefined
  }),
  computed: {
    ...mapState({
      selectedTravellers: state => state.fb.passengersInformation.selectedTravellers,
      itinerary: state => state.fb.searchResults.updatedSelectedItinerary
    }),
    ...mapGetters({
      canSubmit: 'fb/passengersInformation/getValidity'
    })
  },
  created () {
    this.determineLuggageIncluded()
    this.determineLuggageOptions()
  },
  methods: {
    ...mapActions({
      submitForm: 'fb/flightDetailsPostAction'
    }),
    determineLuggageIncluded () {
      this.luggageIncluded = {
        outward: this.itinerary.flight_outward?.details[0].included_luggage,
        return: this.itinerary.flight_return?.details[0].included_luggage
      }
    },
    determineLuggageOptions () {
      if (this.itinerary.luggage_options_params) {
        const {
          OutwardLuggageOptions,
          ReturnLuggageOptions,
          LuggageOptions
        } = this.itinerary.luggage_options_params

        // si LH pas de bagages en option
        if (this.itinerary.flight_outward.segments[0].marketing_carrier === 'LH') {
          this.areLuggageOptionsOutward = false
          this.areLuggageOptionsReturn = false
          this.areLuggageOptionsCommon = false
        } else {
          this.areLuggageOptionsOutward = OutwardLuggageOptions?.options && !OutwardLuggageOptions?.per_passenger
          this.areLuggageOptionsReturn = ReturnLuggageOptions?.options && !ReturnLuggageOptions?.per_passenger
          this.areLuggageOptionsCommon = LuggageOptions?.options && !LuggageOptions?.per_passenger
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
